module.exports = __webpack_public_path__ + "assets-cabinet/img/off-icon.68572857.svg";